import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import Context from '../../../setup/context'
import { Link } from 'react-router-dom'
import { Image as SkeletonImage, Detail1 as SkeletonDetail } from './skeletonItem'
import QuantityInput from '../../../pageComponents/_common/form/quantityInput'
import AirlineChip from '../../../pageComponents/_common/styledComponents/AirlineChip'
import LocationsModal from '../../_common/modals/LocationsModal'
import CustomerPartModal from '../../_common/modals/CustomerPartModal'
import { AIRLINE_ENGINEER_USER, IMPERSONATOR_USER } from '../../../pageComponents/_common/constants/UserTypeConstants'
import ItemImage from '../../_common/ItemImage'
import SubstituteLink from 'pageComponents/_common/SubstituteLink'
import NotifyMeButton from 'pageComponents/ItemDetail/uiComponents/notifyMe'
import RequestPriceButton from 'pageComponents/_common/RequestPriceButton'
import Restricted from 'pageComponents/_common/Restricted'
import EmployeeAddButton from 'pageComponents/_common/EmployeeAddButton'
import { gtag } from 'ga-gtag';
import { useLazyQuery } from '@apollo/client'
import { GET_ITEM_FAMILY_DETAILS } from 'setup/gqlQueries/gqlItemQueries'

const DivItemResultContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 320px;
	min-height: 350px;
	margin: 0 8px 20px 8px;
	padding: 8px 0;
	border-bottom: 1px grey solid;
`

const DivPartNumberRow = styled.div`
	width: 100%;
	display: flex;
	color: #000;
	padding: 0 5px;
	font-size: 12px;
	font-family: Arial, sans-serif;
`
const ExtendedDescSpan = styled.span`
    padding: 0 5px;
    font-size: 12px;
    font-weight: bold;
    color: #555;
    font-family: Arial, sans-serif;
    width: 100%;
    display: block; /* Fallback for non-webkit */
    display: -webkit-box;
    height: 36px; /* Fallback for non-webkit */
    margin: 0 auto;
    line-height: 1.5;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;

`

const DivPartNumberRowSpread = styled(DivPartNumberRow)`
	justify-content: space-between;
`

const P = styled.p`
	margin: 0;
	font-weight: 500;
	margin: 0 4px;
`

const DivPartDetailsRow = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	flex-grow: 99;
	background-color: #fff;
	width: 100%;
`

const DivPartImg = styled.div`
	display: flex;
	width: 150px;
	height: 150px;
	background-color: white;
`

const DivPartDetails = styled.div`
	display: flex;
	flex-direction: column;
	padding: 4px;
`

const PartTitleLink = styled(Link)`
	margin: 0;
	font-weight: 700;
	font-size: 15px;
	color: #000000 !important;
	height: 36px;
    line-height: 1.25;
	overflow: hidden;
	&:hover{
		cursor: pointer;
		color: #328EFC;
	}
`

const PartTitleItemCatalog = styled.p`
	margin: 0;
	font-weight: 700;
	font-size: 15px;
	color: #000000 !important;
	height: 36px;
    line-height: 1.25;
	overflow: hidden;
	&:hover{
		cursor: pointer;
		color: #328EFC;
	}
`

const PpartAvailability = styled.p`
	margin: 0 5px 0 0;
	font-size: 13px;
`

export const ButtonBlue = styled.button`
    color: white;
    text-decoration: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: 'white !important';
    background: #0368e0;
    background: linear-gradient(to top left, #0368e0, #328efc);
    padding: 4px 12px;
    box-shadow: 1px 1px 2px black;
    font-size: 12px;
    font-weight: 600;
    border: none;
    margin: 5px;
    svg {
        margin-right: 5px;
    }
    &:hover {
        color: white;
        text-decoration: none;
    }
`

const ButtonRed = styled.button`
	background-color: #b51029;
	color: white;
	font-weight: 600;
	border: 0;
	padding: 4px 8px;
	box-shadow: 1px 1px 2px #000;
	margin: 11px auto 7px;
	&:hover{
		background-color: rgb(219, 22, 51);
	}
	&:active{
		background-color: #b51029;
		box-shadow: 0px 0px 1px #000;
	}
`
const MoreDetailsLink = styled(Link)`
	width: max-content;
	background-color: white;
	color: #328EFC;
	font-weight: 600;
	font-size: 12px;
	border: 0;
	margin-top: 4px;
`

const MoreDetailsCatalogItem = styled.p`
	width: max-content;
	background-color: white;
	color: #328EFC;
	font-weight: 600;
	font-size: 12px;
	border: 0;
	margin-top: 4px;
`

const Div = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`

const DivSpace = styled(Div)`
	width: 100%;
	justify-content: space-between;
	align-items: flex-end;
	flex-grow: 99;
`

const Pprice = styled.p`
	color: #328EFC;
	font-size: 18px;
	font-weight: 700;
	padding: 0 4px;
	margin: 0;
`

const PlistPrice = styled.p`
	color: #328EFC;
	font-size: 14px;
	font-weight: 700;
	padding: 0 4px;
    margin: 0;
    text-decoration: line-through;
`

const ACall = styled.a`
	color: #328EFC;
	font-weight: 700;
	padding: 0 4px;
`

const ImgContainer = styled.div`
	margin: auto;
`

export const Center = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`

export const NoHoverLink = styled(Link)`
    &:hover {
        text-decoration: none;
    }
`

export default function ItemResult({ result, details, addedToCart, isParentCalculateStock, itemCreationFlag, hasSub }) {
    const { itemAvailabilities, customerPartNumbers, itemPrices, addItem, addCatalogItem, userInfo, stockAvailabilities } = useContext(Context)
    const [foundAvailability, setFoundAvailability] = useState({})
    const [onOrder, setOnOrder] = useState(null)
    const [price, setPrice] = useState({})

    const availabilityFound = itemAvailabilities.find(avail => avail.invMastUid === result.invMastUid)

    const foundPrice = itemPrices.find(item => item.invMastUid === result.invMastUid)

    const quantityAvailableToMake = stockAvailabilities.find(s => s.invMastUid === foundAvailability.invMastUid)?.airlineStock?.[0]?.quantityAvailableToMake

    const [getFamilyInfo, { data: familyInfo }] = useLazyQuery(GET_ITEM_FAMILY_DETAILS, {
        fetchPolicy: 'no-cache',
        onCompleted: result => {
            const calculatedAvailability = Math.floor(parseInt(availability) / parseInt(result.itemFamilyDetails?.customizerOptions.find(c => c.kind === "CutToLength").maximumLengthX))
            setFoundAvailability({...foundAvailability, availability: calculatedAvailability})
        }
    })

    useEffect(() => {
        if (availabilityFound) {
            setFoundAvailability(availabilityFound)
        }
        if (result.itemCatalogUid) {
            setFoundAvailability({
                totalQuantity: 0,
                availability: 0
            })
        }
    }, [availabilityFound, result.itemCatalogUid])

    useEffect(() => {
        if (details?.itemFamilies?.length > 0) {
            const c2lMaterial = details.itemFamilies?.flatMap(i => i.members).find(m => m.relationshipToFamily === "CutToLengthMaterial")
            getFamilyInfo({variables: { familyHeadInvMastUid: details.invMastUid, memberInvMastUid: c2lMaterial?.invMastUid }})
        }
    }, [details?.itemFamilies])

    useEffect(() => {
        if (foundPrice) {
            setPrice(foundPrice)
        }
        if (result.itemCatalogUid) {
            setPrice({
                unitPrice: result.listPrice,
                unitOfMeasure: 'EA',
                unitSize: 1,
                roundType: 'U'
            })
        }
    }, [foundPrice, result.itemCatalogUid])

    const {
        unitPrice,
        listPrice,
        unitOfMeasure,
        unitSize,
        roundType
    } = price

    const isCatalogItem = !!result.itemCatalogUid
    const [quantity, setQuantity] = useState(1)

    const [customerPartNumberId, setCustomerPartNumberId] = useState(0)
    const [customerPartNumber, setCustomerPartNumber] = useState('')
    const [customerPartOptions, setCustomerPartOptions] = useState([])

    useEffect(() => {
        const filteredCustomerPartNumbers = customerPartNumbers.filter(c => c.invMastUid === result.invMastUid)
        setCustomerPartOptions(filteredCustomerPartNumbers)
        if (filteredCustomerPartNumbers?.length === 1) {
            setCustomerPartNumberId(filteredCustomerPartNumbers[0].id)
            setCustomerPartNumber(filteredCustomerPartNumbers[0].customerPartNumber)
        }
    }, [customerPartNumbers, result.invMastUid])

    const itemDetailsLink = isCatalogItem
        ? null
        : `/product/${details.itemCodeUrlSanitized || encodeURIComponent(result.itemCode)}/${result.invMastUid}${customerPartNumber ? `/${customerPartNumber}` : ''}`

    const bomLink = `/productinfo/${details.itemCodeUrlSanitized || encodeURIComponent(result.itemCode)}/${result.invMastUid}${customerPartNumber ? `/${customerPartNumber}` : ''}`

    const handleAddToCart = () => {
        if (isCatalogItem) {
            addCatalogItem({
                itemCatalogUid: result.itemCatalogUid,
                quantity: parseInt(quantity)
            })
        } else {
            addItem({
                invMastUid: result.invMastUid,
                quantity: parseInt(quantity),
                itemUnitPriceOverride: null,
                customerPartNumberId: customerPartNumberId || 0,
                supplierId: details.supplierId
            })
        }

        try {
            gtag(
                "event", "add_to_cart", {
                items: [
                    {
                        item_id: result.itemCode,
                        item_name: result.itemDescription
                    }
                ]
            }
            );
        } catch {
        }
        addedToCart(result.invMastUid)
        setQuantity(1)
    }

    function cpnModal_onSelectedChanged(value) {
        if (value === '-1') {
            setCustomerPartNumberId(0) // Reset Dropdown
        } else {
            setCustomerPartNumberId(Number(value))
        }
    }

    function cpnModal_onClearSelected() {
        setCustomerPartNumberId(0)
    }

    const { availability } = foundAvailability
    const bomInStock = quantityAvailableToMake > 0

    return (
        <DivItemResultContainer>
            <DivPartDetailsRow>
                {
                    isCatalogItem ? (
                        <>
                            <DivPartImg>
                                <ImgContainer>
                                    <ItemImage {...{ details, size: 'large', textSize: 'large' }} />
                                </ImgContainer>
                            </DivPartImg>
                            <MoreDetailsCatalogItem>Catalog Item</MoreDetailsCatalogItem>
                        </>
                    ) : (
                        <>
                            <Link to={itemDetailsLink}>
                                <DivPartImg>
                                    {!details.itemMedia ? (
                                        <SkeletonImage />
                                    ) : (
                                        <ImgContainer>
                                            <ItemImage {...{ details, size: 'large', textSize: 'large' }} />
                                        </ImgContainer>
                                    )}
                                </DivPartImg>
                            </Link>
                            <MoreDetailsLink to={itemDetailsLink}>More Details</MoreDetailsLink>
                        </>
                    )
                }

                <DivPartDetails>
                    {
                        isCatalogItem ? (
                            <PartTitleItemCatalog>{result.itemDescription}</PartTitleItemCatalog>
                        ) : (
                            <PartTitleLink to={itemDetailsLink}>{result.itemDescription}</PartTitleLink>
                        )
                    }
                </DivPartDetails>

                {
                    isCatalogItem ? (
                        <ExtendedDescSpan>
                            {result.extendedDescription}
                        </ExtendedDescSpan>
                    ) : (
                        <>
                            {
                                !details ? (
                                    <>
                                        <div style={{ width: '100%' }}>
                                            <SkeletonDetail style={{ width: '85%', margin: '5px' }} />
                                            <SkeletonDetail style={{ width: '60%', margin: '5px' }} />
                                        </div>
                                    </>
                                ) : (
                                    <ExtendedDescSpan dangerouslySetInnerHTML={{ __html: details?.extendedDesc }} />

                                )
                            }
                        </>
                    )
                }
                <DivPartNumberRow>
                    <Restricted {...{ userInfo, details }} />
                </DivPartNumberRow>
                <DivPartNumberRow>
                    <PpartAvailability>Item Id: {result.itemCode}</PpartAvailability>
                </DivPartNumberRow>

                <DivPartNumberRow>
                    {
                        isCatalogItem ? (
                            <PpartAvailability>Airline #: CAT{result.itemCatalogUid}</PpartAvailability>
                        ) : (
                            <PpartAvailability>Airline #: AHC{result.invMastUid}</PpartAvailability>
                        )
                    }
                </DivPartNumberRow>
                
                {!!result.nsn && <DivPartNumberRow>
                    <PpartAvailability>NSN#: {result.nsn}</PpartAvailability>
                </DivPartNumberRow>}

                {!!customerPartOptions.length && (
                    <DivPartNumberRow>
                        <PpartAvailability>
                            Customer Part #:
                        </PpartAvailability>
                        <CustomerPartModal
                            invMastUid={result.invMastUid}
                            customerPartNumbers={customerPartOptions}
                            selectedCustomerPartNumberId={customerPartNumberId}
                            onSelectedChanged={cpnModal_onSelectedChanged}
                            onClearSelected={cpnModal_onClearSelected}
                        />
                    </DivPartNumberRow>
                )}
                {!itemCreationFlag && (
                    <>
                                <LocationsModal
                                    invMastUid={result.invMastUid}
                                    availabilityInfo={foundAvailability}
                                    unitPrice={unitPrice}
                                    isParentCalculateStock={isParentCalculateStock}
                                    isAssembly={result.isAssembly}
                                    setOnOrder={setOnOrder}
                                />
                                {hasSub && <SubstituteLink to={`${itemDetailsLink}#sub`} />}
                                {(availability === 0 && bomInStock) && (
                                    <NoHoverLink to={bomLink}>
                                        <ButtonBlue>
                                            Components Available
                                        </ButtonBlue>
                                    </NoHoverLink>
                                )}
                            {details.itemFamilies?.length > 0 && details.itemFamilies?.some((i => i.familyInvMastUid === details.invMastUid)) ? 
                            (
                                    <Center style={{margin: 'auto'}}>
                                        <NoHoverLink to={itemDetailsLink}>
                                            <ButtonBlue>Customize Length</ButtonBlue>
                                        </NoHoverLink>
                                    </Center>
                            )
                            
                            : 
                            
                            (
                            <>
                                <DivPartNumberRowSpread>
                                    <Div>
                                        <span>Quantity:</span>
                                        <QuantityInput
                                            quantity={quantity}
                                            unitSize={unitSize}
                                            unitOfMeasure={unitOfMeasure}
                                            roundType={roundType}
                                            handleUpdate={setQuantity}
                                            min='0'
                                        />
                                        {(unitSize > 1) && (
                                            <AirlineChip style={{ marginLeft: '0.5rem' }}>
                                                X {unitSize}
                                            </AirlineChip>
                                        )}
                                    </Div>

                                    {
                                        isCatalogItem ? (
                                            <>
                                                {
                                                    unitPrice ? (
                                                        <>
                                                            <DivPartDetails>
                                                                <Div>
                                                                    <PlistPrice>${unitPrice.toFixed(2)}</PlistPrice>
                                                                    <P>/{unitOfMeasure}</P>

                                                                </Div>
                                                                <Div>
                                                                    Add To Cart For Price
                                                                </Div>
                                                            </DivPartDetails>
                                                        </>
                                                    ) : (
                                                        <ACall href="tel:+18009997378">Call for Price</ACall>
                                                    )
                                                }
                                            </>
                                        ) : (
                                            <>
                                                {unitPrice ? (
                                                    <>
                                                        <DivPartDetails>
                                                            {listPrice && (
                                                                <Div>
                                                                    <PlistPrice>${listPrice.toFixed(2)}</PlistPrice>
                                                                </Div>
                                                            )}
                                                            <Div>
                                                                <Pprice>${unitPrice.toFixed(2)}</Pprice>
                                                                <P>/{unitOfMeasure}</P>
                                                            </Div>
                                                        </DivPartDetails>
                                                    </>
                                                ) : !foundPrice ? (
                                                    <Div>
                                                        <SkeletonDetail style={{ margin: 'auto 0 auto 75px', width: 50 }} />
                                                    </Div>
                                                ) : (
                                                    <ACall href="tel:+18009997378">Call for Price</ACall>
                                                )}
                                            </>
                                        )
                                    }

                                </DivPartNumberRowSpread>

                                {onOrder && (
                                    <Center>
                                        <NotifyMeButton onOrder={onOrder} />
                                    </Center>
                                )}

                                <DivSpace>
                                    {(userInfo && [AIRLINE_ENGINEER_USER, IMPERSONATOR_USER].includes(userInfo.role)) ? (
                                        <EmployeeAddButton {...{ details, handleAddToCart }} />
                                    ) :
                                        (isCatalogItem || !!unitPrice) ? (
                                            <ButtonRed onClick={handleAddToCart}>Add to Cart</ButtonRed>
                                        ) : (
                                            <Center>
                                                <RequestPriceButton {...{ invMastUid: result.invMastUid }} />
                                            </Center>
                                        )
                                    }
                                </DivSpace>
                            </>
                        )}
                    </>
                )}
            </DivPartDetailsRow>
        </DivItemResultContainer>
    )
}
